import { ProductsActionType } from './enums';
import { ProductsAction, ProductsState } from './interfaces';

export const initialState: ProductsState = {
	error: null,
	loading: false,
	inspirationsCategoriesList: [],
	totalRecords: 0,
	categorySubCategory: {},
	productsLoading: false,
	productsError: null,
	productsList: [],
	categoryList: [],
	categoryListLoading: false,
	subCategoryList: [],
	subCategoryListLoading: false,
	productDetails: {},
	productDetailsLoading: false,
	productDetailsError: null,
	productItemHistory: [],
	productItemHistoryLoading: false,
	productItemHistoryError: null,
	productWarrantyList: [],
	productWarrantyListError: null,
	productWarrantyListLoading: false,
	productItemsList: [],
	productItemsListError: null,
	productItemsListLoading: false,
	productAreaList: [],
	areaList: [],
	warrantyDetailsByCodes: [],
	warrantyDetailsByCodesLoading: false,
	warrantyDetailsByCodesError: null,
	internalCategories: [],
	internalCategoriesLoading: false,
	internalCategoriesError: null,
	xorGroups: [],
	productGroups: [],
	productTaxonomyLoading: false,
	productTaxonomyError: null,
	defaultModels: [],
	defaultModelsLoading: false
};

export default (state = initialState, { type, payload }: ProductsAction): ProductsState => {
	switch (type) {
		case ProductsActionType.FETCH_ALL_INSPIRATIONS_CATEGORY: {
			return {
				...state,
				loading: true
			};
		}

		case ProductsActionType.STORE_ALL_INSPIRATIONS_CATEGORY: {
			return {
				...state,
				loading: false,
				inspirationsCategoriesList: payload.category,
				totalRecords: payload.totalRecords
			};
		}

		case ProductsActionType.ERROR_ALL_INSPIRATIONS_CATEGORY: {
			return {
				...state,
				loading: false,
				error: payload.error
			};
		}

		case ProductsActionType.FETCH_ALL_INSPIRATIONS_PRODUCTS: {
			return {
				...state,
				productsLoading: true
			};
		}

		case ProductsActionType.STORE_ALL_INSPIRATIONS_PRODUCTS: {
			return {
				...state,
				productsLoading: false,
				productsList: payload.item,
				totalRecords: payload.totalRecords
			};
		}

		case ProductsActionType.ERROR_ALL_INSPIRATIONS_PRODUCTS: {
			return {
				...state,
				productsLoading: false,
				productsError: payload.error
			};
		}

		case ProductsActionType.FETCH_PRODUCT_CATEGORIES: {
			return {
				...state,
				categoryListLoading: false
			};
		}

		case ProductsActionType.STORE_PRODUCT_CATEGORIES: {
			return {
				...state,
				categoryListLoading: false,
				categoryList: payload
			};
		}

		case ProductsActionType.FETCH_PRODUCT_SUB_CATEGORIES: {
			return {
				...state,
				subCategoryListLoading: false
			};
		}

		case ProductsActionType.STORE_PRODUCT_SUB_CATEGORIES: {
			return {
				...state,
				subCategoryListLoading: false,
				subCategoryList: payload
			};
		}

		case ProductsActionType.STORE_PRODUCT_DETAILS: {
			return {
				...state,
				productDetailsLoading: false,
				productDetails: payload
			};
		}

		case ProductsActionType.FETCH_PRODUCT_ITEM_HISTORY: {
			return {
				...state,
				productItemHistoryLoading: true,
				productItemHistoryError: null
			};
		}

		case ProductsActionType.STORE_PRODUCT_ITEM_HISTORY: {
			return {
				...state,
				productItemHistoryLoading: false,
				productItemHistory: Array.isArray(payload?.entries) ? payload.entries : []
			};
		}

		case ProductsActionType.ERROR_PRODUCT_ITEM_HISTORY: {
			return {
				...state,
				productItemHistoryLoading: false,
				productItemHistoryError: payload.error
			};
		}

		case ProductsActionType.FETCH_PRODUCT_TAXONOMY: {
			return {
				...state,
				productTaxonomyLoading: true,
				productTaxonomyError: null
			};
		}

		case ProductsActionType.STORE_PRODUCT_TAXONOMY: {
			const taxonomyPayload = payload as any;
			return {
				...state,
				productTaxonomyLoading: false,
				xorGroups: taxonomyPayload.xorGroups || [],
				productGroups: taxonomyPayload.productGroups || []
			};
		}

		case ProductsActionType.ERROR_PRODUCT_TAXONOMY: {
			return {
				...state,
				productTaxonomyLoading: false,
				productTaxonomyError: (payload as any).error
			};
		}

		case ProductsActionType.ERROR_PRODUCT_DETAILS: {
			return {
				...state,
				productDetailsLoading: false,
				error: payload.error
			};
		}

		case ProductsActionType.STORE_ALL_PRODUCTS_WARRANTY: {
			return {
				...state,
				productWarrantyListLoading: false,
				productWarrantyList: payload.warranty,
				totalRecords: payload.totalRecords
			};
		}

		case ProductsActionType.ERROR_ALL_PRODUCTS_WARRANTY: {
			return {
				...state,
				productWarrantyListLoading: false,
				productWarrantyListError: payload.error
			};
		}

		case ProductsActionType.FETCH_PRODUCT_ITEMS_DROPDOWN:
		case ProductsActionType.FETCH_PRODUCT_ITEMS_DROPDOWN_V2: {
			return {
				...state,
				productItemsListLoading: true
			};
		}

		case ProductsActionType.STORE_PRODUCT_ITEMS_DROPDOWN: {
			return {
				...state,
				productItemsListLoading: false,
				productItemsList: payload
			};
		}

		case ProductsActionType.ERROR_PRODUCT_ITEMS_DROPDOWN: {
			return {
				...state,
				productItemsListLoading: false,
				productItemsListError: payload.error
			};
		}

		case ProductsActionType.STORE_PRODUCT_AREA_LIST_DROPDOWN: {
			return {
				...state,
				productAreaList: payload.area
			};
		}
		case ProductsActionType.STORE_QUOTATION_AREA_LIST_DROPDOWN: {
			return {
				...state,
				areaList: payload
			};
		}

		case ProductsActionType.FETCH_WARRANTY_DETAILS_BY_CODES: {
			return {
				...state,
				warrantyDetailsByCodesLoading: true,
				warrantyDetailsByCodesError: null
			};
		}

		case ProductsActionType.STORE_WARRANTY_DETAILS_BY_CODES: {
			return {
				...state,
				warrantyDetailsByCodesLoading: false,
				warrantyDetailsByCodes: payload
			};
		}

		case ProductsActionType.ERROR_WARRANTY_DETAILS_BY_CODES: {
			return {
				...state,
				warrantyDetailsByCodesLoading: false,
				warrantyDetailsByCodesError: payload.error
			};
		}

		case ProductsActionType.FETCH_INTERNAL_CATEGORIES: {
			return {
				...state,
				internalCategoriesLoading: true,
				internalCategoriesError: null
			};
		}

		case ProductsActionType.STORE_INTERNAL_CATEGORIES: {
			return {
				...state,
				internalCategoriesLoading: false,
				internalCategories: Array.isArray(payload) ? payload : []
			};
		}

		case ProductsActionType.ERROR_INTERNAL_CATEGORIES: {
			return {
				...state,
				internalCategoriesLoading: false,
				internalCategoriesError: payload.error
			};
		}

		case ProductsActionType.FETCH_DEFAULT_MODELS: {
			return {
				...state,
				defaultModelsLoading: true
			};
		}

		case ProductsActionType.STORE_DEFAULT_MODELS: {
			return {
				...state,
				defaultModelsLoading: false,
				defaultModels: Array.isArray(payload) ? payload : []
			};
		}

		default:
			return state;
	}
};
